import {
  Footer as AppFooter,
  Flex,
  Tooltip,
  config as cssConfig,
} from "@100mslive/react-ui";
import {
  HMSPlaylistType,
  selectIsAllowedToPublish,
  selectLocalPeerRoleName,
  useHMSStore,
  useScreenShare,
} from "@100mslive/react-sdk";
import React, { Fragment, useEffect, useState } from "react";

import { AudioVideoToggle } from "../AudioVideoToggle";
import { CabinSelectLangs } from "../CabinSelectLanguages";
import { ChatToggle } from "./ChatToggle";
import { EmojiReaction } from "../EmojiReaction";
import { FEATURE_LIST } from "../../common/constants";
import { FeatureFlags } from "../../services/FeatureFlags";
import IconButton from "../../IconButton";
import { LeaveRoom } from "../LeaveRoom";
import MetaActions from "../MetaActions";
import { MoreSettings } from "../MoreSettings/MoreSettings";
import { MusicIcon } from "@100mslive/react-icons";
import { PIP } from "../PIP";
import { Playlist } from "../../components/Playlist/Playlist";
import { ROLES } from "../../common/roles";
import { ScreenShareHintModal } from "../ScreenshareHintModal";
import { ScreenshareToggle } from "../ScreenShare";
import { ToggleWhiteboard } from "../../plugins/whiteboard";
import { VirtualBackground } from "../../plugins/VirtualBackground/VirtualBackground";
import { isScreenshareSupported } from "../../common/utils";
import { useIsFeatureEnabled } from "../hooks/useFeatures";
import { useMedia } from "react-use";
import { useMyMetadata } from "../hooks/useMetadata";

const TranscriptionButton = React.lazy(() =>
  import("../../plugins/transcription")
);

const ScreenshareAudio = () => {
  const {
    amIScreenSharing,
    screenShareVideoTrackId: video,
    screenShareAudioTrackId: audio,
    toggleScreenShare,
  } = useScreenShare();
  const isAllowedToPublish = useHMSStore(selectIsAllowedToPublish);
  const isAudioScreenshare = amIScreenSharing && !video && !!audio;
  const [showModal, setShowModal] = useState(false);
  const isFeatureEnabled = useIsFeatureEnabled(
    FEATURE_LIST.AUDIO_ONLY_SCREENSHARE
  );
  if (
    !isFeatureEnabled ||
    !isAllowedToPublish.screen ||
    !isScreenshareSupported()
  ) {
    return null;
  }
  return (
    <Fragment>
      <Tooltip
        title={`${!isAudioScreenshare ? "Bắt đầu" : "Dừng"} chia sẻ âm thanh`}
        key="shareAudio"
      >
        <IconButton
          active={!isAudioScreenshare}
          onClick={() => {
            if (amIScreenSharing) {
              toggleScreenShare();
            } else {
              setShowModal(true);
            }
          }}
          data-testid="screenshare_audio"
        >
          <MusicIcon />
        </IconButton>
      </Tooltip>
      {showModal && (
        <ScreenShareHintModal onClose={() => setShowModal(false)} />
      )}
    </Fragment>
  );
};

export const ConferencingFooter = () => {
  const isMobile = useMedia(cssConfig.media.md);
  const localPeerRole = useHMSStore(selectLocalPeerRoleName);
  const { isHandRaised, isBRBOn, toggleHandRaise, toggleBRB } = useMyMetadata();

  // useEffect(() => {
  //   console.log(isHandRaised)
  // }, [isHandRaised])

  return (
    <AppFooter.Root>
      <AppFooter.Left>
        {/* <ScreenshareAudio /> */}
        <Playlist type={HMSPlaylistType.audio} />
        <Playlist type={HMSPlaylistType.video} />
        {FeatureFlags.enableWhiteboard ? <ToggleWhiteboard /> : null}
        <VirtualBackground />
        {FeatureFlags.enableTranscription ? <TranscriptionButton /> : null}
        <Flex
          align="center"
          css={{
            display: "none",
            "@md": {
              display: "flex",
              gap: "$8",
            },
          }}
        >
          {/* {isMobile && <EmojiReaction />} */}
          <MetaActions
            isMobile
            isHandRaised={isHandRaised}
            isBRBOn={isBRBOn}
            toggleHandRaise={toggleHandRaise}
            toggleBRB={toggleBRB}
          />
        </Flex>
      </AppFooter.Left>
      <AppFooter.Center>
        <AudioVideoToggle />
        <ScreenshareToggle />
        <PIP />
        {localPeerRole === ROLES.GUEST && <CabinSelectLangs />}
        <MoreSettings />
        <Flex
          align="center"
          css={{ display: "none", "@md": { display: "flex" } }}
        >
          <ChatToggle />
        </Flex>
        <LeaveRoom />
      </AppFooter.Center>
      <AppFooter.Right>
        {/* {!isMobile && <EmojiReaction />} */}
        <MetaActions
          isHandRaised={isHandRaised}
          isBRBOn={isBRBOn}
          toggleHandRaise={toggleHandRaise}
          toggleBRB={toggleBRB}
        />
        <ChatToggle />
      </AppFooter.Right>
    </AppFooter.Root>
  );
};
